// Grozd brand tokens — single source of truth
// PRAVILO 12: nikad hex u komponentama, uvijek var(--*) ili token import

export const tokens = {
  color: {
    // Brand
    primary: "#5A3AB5",
    deep: "#2D1B69",
    p100: "#E6E0F5",
    p300: "#C5B7EE",
    light: "#F2EEF9",
    tint: "#F9F6FD",

    // Neutrals
    ink: "#1A1A2E",
    n50: "#F4F4F6",
    n100: "#E5E5EA",
    n200: "#D1D1D6",
    n400: "#8E8E93",
    n600: "#48484A",
    white: "#FFF",

    // Status
    success: "#34C759",
    warning: "#FF9500",
    danger: "#FF3B30",
    info: "#007AFF",
  },
  font: {
    brand: "'Manrope', system-ui, sans-serif",
    body: "'Inter', system-ui, sans-serif",
    mono: "'JetBrains Mono', 'SF Mono', monospace",
  },
  motion: {
    fast: "150ms",
    medium: "400ms",
    ease: "cubic-bezier(.22,1,.36,1)",
  },
  radius: {
    sm: "6px",
    md: "10px",
    lg: "14px",
    xl: "16px",
  },
} as const;

export type Tokens = typeof tokens;
